(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon/coupon-regular.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon/coupon-regular.js');

'use strict';

svs.matchen = svs.matchen || {};
svs.matchen.views = svs.matchen.views || {};

svs.matchen.views.CouponRegular = Marionette.View.extend({
  topHidden: true,

  bottomHidden: true,

  template: function(data) {
    return svs.matchen.templates.coupon_regular(data);
  },

  ui: {
    upArrow: '.js-toggle-up',
    downArrow: '.js-toggle-down'
  },

  events: {
    'click .js-toggle-up': 'toggleUp',
    'click .js-toggle-down': 'toggleDown'
  },

  regions: {
    home: '.region-home',
    away: '.region-away',
    reductions: '.region-reductions'
  },

  initialize: function() {
    this.initListeners();
  },

  toggleUp: function() {
    this.topHidden = !this.topHidden;
    this.model
      .get('draw')
      .getHomeOutcomes()
      .toggleTopHeatmap(this.topHidden);
    this.model
      .get('draw')
      .getAwayOutcomes()
      .toggleTopHeatmap(this.topHidden);
    if (this.topHidden) {
      this.ui.upArrow.text('Visa färre -');
    } else {
      this.ui.upArrow.text('Visa fler +');
    }

  },

  toggleDown: function() {
    this.bottomHidden = !this.bottomHidden;
    this.model
      .get('draw')
      .getHomeOutcomes()
      .toggleBottomHeatmap(this.bottomHidden);
    this.model
      .get('draw')
      .getAwayOutcomes()
      .toggleBottomHeatmap(this.bottomHidden);
    if (this.bottomHidden) {
      this.ui.downArrow.text('Visa fler +');
    } else {
      this.ui.downArrow.text('Visa färre -');
    }

  },

  initListeners: function() {
    this.listenTo(
      svs.matchen.tipsInfo,
      'change:svenskaFolket',
      this.onChangeSvenskaFolket
    );
  },

  onChangeSvenskaFolket: function() {
    this.getRegion('home').currentView.render();
    this.getRegion('away').currentView.render();

  },

  onRender: function() {
    this.showChildView(
      'home',
      new svs.matchen.views.Team({
        outcomes: this.model.get('draw').getHomeOutcomes()
      })
    );

    this.showChildView(
      'away',
      new svs.matchen.views.Team({
        outcomes: this.model.get('draw').getAwayOutcomes()
      })
    );

    this.showChildView(
      'reductions',
      new svs.matchen.views.Reductions({
        collection: this.model.get('reductionsRegular')
      })
    );
  }
});


 })(window);